import React, { useEffect, useRef } from "react";
import { useSetState } from "ahooks";
import Toast from "../../../../components/toast";
import Modal from "../../../../components/modal";
import { classNames } from "../../../../tool";
import styles from "./index.module.scss";
import toast from "../../../../components/toast";

const DEFAULT_ARR = [5, 10, 50, 100, 200];
const MAX = 50000;
const MAX_MULTIPLE = 50;
const chipMap = {
  0: "一",
  1: "二",
  2: "三",
  3: "四",
  4: "五",
};
const BetArea = (props) => {
  const {
    className,
    resetChipCount,
    selectPlays,
    showSelectPlays,
    firstPlay,
    onDelete,
    handleRandom,
    onBet, // 点击投注或者购物车
    onChangeBetMoney,
    betMoney,
  } = props;
  let localArr = localStorage.getItem("amountArr")
    ? JSON.parse(localStorage.getItem("amountArr"))
    : DEFAULT_ARR;
  localArr = localArr.slice(0, 5);
  const [state, setState] = useSetState({
    chip: localArr,
    cacheChip: localArr,
    cacheInput: localArr,
    edit: false,
    activeIndex: -1,
    selMultiple: 1,
    successVisible: false,
    failVisible: false,
    balanceVisible: false,
  });

  const {
    chip,
    cacheChip,
    cacheInput,
    edit,
    activeIndex,
    successVisible,
    failVisible,
    selMultiple,
    balanceVisible,
  } = state;
  const realChip = chip.slice(0, 5);
  useEffect(() => {
    if (resetChipCount) {
      setState({
        activeIndex: "",
      });
    }
  }, [resetChipCount]);

  const isSpecialRef = useRef(
    (firstPlay.code === "HX" ||
      firstPlay.code === "LXLW" ||
      firstPlay.code === "LM" ||
      firstPlay.code === "ZXBZ") &&
      showSelectPlays.length > 0
  );
  const realSelectPlaysRef = useRef(false);
  useEffect(() => {
    realSelectPlaysRef.current = selectPlays;
    if (
      (firstPlay.code === "HX" ||
        firstPlay.code === "LXLW" ||
        firstPlay.code === "LM" ||
        firstPlay.code === "ZXBZ") &&
      showSelectPlays.length > 0
    ) {
      isSpecialRef.current = true;
      const arr = showSelectPlays.map((item) => {
        const codeArrInit = item.map((i) => i.code);
        const codeArr = JSON.parse(JSON.stringify(codeArrInit)).reverse();
        const realName = codeArr.join("|");
        return {
          ...item[0],
          name: realName,
        };
      });
      realSelectPlaysRef.current = arr;
    }
    setState({
      selMultiple: selMultiple + 1,
    });
  }, [selectPlays]);
  const onChangeMoney = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    onChangeBetMoney(val);
  };
  const handleClickChip = (item, index) => {
    onChangeBetMoney(Number(betMoney) + Number(item));
    setState({
      activeIndex: index,
    });
  };

  const focusInput = (index) => {
    const arr = JSON.parse(JSON.stringify(cacheInput));
    arr[index] = "";
    setState({
      cacheInput: arr,
    });
  };

  const blurInput = (index) => {
    let arr = JSON.parse(JSON.stringify(cacheChip));
    if (!cacheInput[index]) {
      arr[index] = cacheChip[index];
    }
    arr = arr.map((item) => (item > MAX ? MAX : item < 1 ? 1 : item));
    const newArr = JSON.parse(JSON.stringify(arr));
    setState({
      cacheInput: newArr,
    });
    // 延时器是为了在确定时能有toast提示
    setTimeout(() => {
      const newArr2 = JSON.parse(JSON.stringify(arr));
      setState({
        cacheChip: newArr2,
      });
    }, 100);
  };

  const changeInput = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const arr = JSON.parse(JSON.stringify(cacheChip));
    arr[index] = val;
    if (arr[index] > MAX) {
      arr[index] = MAX;
    }
    setState({
      cacheChip: arr,
      cacheInput: arr,
    });
  };

  const handleOk = () => {
    let errText = "";
    const max = activeIndex > 5 ? MAX_MULTIPLE : MAX;
    const arr = cacheChip.map((item) => {
      let res = item;
      if (item > MAX) {
        errText = `最大设置${activeIndex > 5 ? "倍数" : "金额"}为${max}`;
        res = max;
      } else if (item < 1) {
        res = 1;
      }
      return res;
    });
    if (errText) {
      Toast(errText);
    }
    setState({
      edit: false,
      chip: arr,
    });
    localStorage.setItem("amountArr", JSON.stringify(arr));
  };

  return (
    <div className={classNames(styles.betArea, className)}>
      <div className={styles.total}>
        <span>共计{realSelectPlaysRef.current.length || 0}注</span>
        <span>总计{realSelectPlaysRef.current.length * betMoney || 0}元</span>
        {/* <span>/</span>
        <span>预估可赢{betMoney || 0}元</span> */}
      </div>
      <div className={styles.chipArea}>
        <div className={styles.quick} onClick={() => setState({ edit: true })}>
          <img src={require("../../../../assets/imgs/new/chipSet.png")} />
        </div>
        <div className={styles.chips}>
          {realChip.map((item, index) => (
            <div
              className={classNames(
                styles.chipBtn,
                activeIndex === index ? styles.chipBtnActive : ""
              )}
              key={index}
              onClick={() => handleClickChip(item, index)}
            >
              {item}
            </div>
          ))}
        </div>
        <div className={styles.random} onClick={handleRandom}>
          <img src={require("../../../../assets/imgs/new/random.png")} />
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.delIcon} onClick={onDelete}>
          <img src={require("../../../../assets/imgs/new/del.png")} />
        </div>
        <div className={styles.shopCart}>
          <img src={require("../../../../assets/imgs/new/icon_cart.png")} />
          <div
            className={styles.cartText}
            onClick={() => {
              if (Number(betMoney)) {
                onBet(1);
              } else {
                toast("请输入投注金额");
              }
            }}
          >
            购物车
            <span>({realSelectPlaysRef.current.length})</span>
          </div>
        </div>
        <div className={styles.inputContainer} data-attribute="input">
          <input
            inputMode="decimal"
            className={styles.moneyInput}
            placeholder="输入金额"
            onChange={onChangeMoney}
            maxLength={8}
            value={betMoney}
          />
        </div>
        <div
          onClick={() => {
            if (betMoney) {
              onBet(2);
            }
          }}
          className={classNames(styles.betBtn, betMoney ? "" : styles.disabled)}
        >
          投注
        </div>
      </div>
      <Modal
        visible={edit}
        close={() => {
          setState({
            edit: false,
          });
        }}
      >
        <div className={styles.editConetnt}>
          <div className={styles.modalTitle}>
            快捷金额设置
            <img
              onClick={() =>
                setState({
                  edit: false,
                  chip: localArr,
                  cacheChip: localArr,
                  cacheInput: localArr,
                })
              }
              className={styles.closeIcon}
              src={require("../../../../assets/imgs/new/icon_close.png")}
            />
          </div>
          <div className={styles.modalTips}>点击金额可重新编辑设置</div>
          <div className={styles.inputContainer}>
            {cacheInput.map((item, idx) => (
              <div className={styles.inputItem} key={idx}>
                <div className={styles.label}>
                  筹码
                  {chipMap[idx]}
                </div>
                <input
                  key={idx}
                  type="tel"
                  value={cacheInput[idx]}
                  placeholder="请输入"
                  onFocus={() => focusInput(idx)}
                  onBlur={() => blurInput(idx)}
                  onChange={(e) => changeInput(e, idx)}
                />
              </div>
            ))}
          </div>
          <div className={styles.footer}>
            <div
              className={classNames(styles.btn, styles.sure)}
              onClick={handleOk}
            >
              确定
            </div>
          </div>
        </div>
      </Modal>

      <Modal visible={successVisible}>
        <div className={classNames(styles.resultModal, styles.success)}>
          <img src={require("../../../../assets/imgs/betSuccess.png")} />
          <span>下注成功</span>
        </div>
      </Modal>
      <Modal visible={failVisible}>
        <div className={classNames(styles.resultModal, styles.fail)}>
          <img src={require("../../../../assets/imgs/betFail.png")} />
          <span>下注失败</span>
        </div>
      </Modal>
      <Modal visible={balanceVisible}>
        <div className={styles.balanceModal}>
          <div className={styles.tips}>
            <img src={require("../../../../assets/imgs/balance.png")} />
            <div className={styles.tips1}>您账户余额不足</div>
            <div className={styles.tips2}>请充值后完成投注</div>
          </div>

          <div className={styles.footer}>
            <div
              onClick={() => {
                setState({
                  balanceVisible: false,
                });
              }}
              className={classNames(styles.btn, styles.cancel)}
            >
              确定
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BetArea;
